
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightningHeavySleetShowersNightColour as ObiLightningHeavySleetShowersNightColourElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-lightning-heavy-sleet-showers-night-colour.js';
 
 
 

 
 export const ObiLightningHeavySleetShowersNightColour = createComponent({
   react: React,
   tagName: 'obi-lightning-heavy-sleet-showers-night-colour',
   elementClass: ObiLightningHeavySleetShowersNightColourElement,
   events: {
     
   }
  });
 
 